import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ConsoleAuthGuard } from "@/components/auth/console-auth-guard";
import { ConsoleLayout } from "@/components/layout/console-layout";
import { LoginPage } from "@/pages/(auth)/login/page";
import { OverviewPage } from "@/pages/(console)/overview/page";
import { UsersPage } from "@/pages/(console)/users/page";
import { UserDetailPage } from "@/pages/(console)/users/[id]/page";
import { BillingPage } from "@/pages/(console)/billing/page";
import { InboxesPage } from "@/pages/(console)/inboxes/page";
import { MessagesPage } from "@/pages/(console)/messages/page";
import { MonitoringPage } from "@/pages/(console)/monitoring/page";
import { PlatformPage } from "@/pages/(console)/platform/page";
import { DatabasePage } from "@/pages/(console)/database/page";
import { DomainsPage } from "@/pages/(console)/domains/page";
import { DomainHealthPage } from "@/pages/(console)/domain-health/page";
import { SupportPage } from "@/pages/(console)/support/page";
import { SponsorsPage } from "@/pages/(console)/sponsors/page";
import { OperatorsPage } from "@/pages/(console)/operators/page";
import { AuditPage } from "@/pages/(console)/audit/page";
import { StatusPage } from "@/pages/(console)/status/page";
import { CleanupPage } from "@/pages/(console)/cleanup/page";
import { EventsPage } from "@/pages/(console)/events/page";
import { NotificationsPage } from "@/pages/(console)/notifications/page";
import { SearchPage } from "@/pages/(console)/search/page";
import { TopConsumersPage } from "@/pages/(console)/top-consumers/page";
import { ApiKeysPage } from "@/pages/(console)/api-keys/page";
import { FeatureFlagsPage } from "@/pages/(console)/feature-flags/page";
import { DisposableDomainsPage } from "@/pages/(console)/disposable/page";
import { RateLimitsPage } from "@/pages/(console)/rate-limits/page";
import { UserWebhooksPage } from "@/pages/(console)/user-webhooks/page";
import { MigrationsPage } from "@/pages/(console)/migrations/page";
import { MaintenancePage } from "@/pages/(console)/maintenance/page";

export function App() {
  return (
    <>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "var(--color-surface)",
            color: "var(--color-text)",
            border: "1px solid var(--color-border)",
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ConsoleAuthGuard>
              <ConsoleLayout />
            </ConsoleAuthGuard>
          }
        >
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="overview" element={<OverviewPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="inboxes" element={<InboxesPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="monitoring" element={<MonitoringPage />} />
          <Route path="platform" element={<PlatformPage />} />
          <Route path="database" element={<DatabasePage />} />
          <Route path="domains" element={<DomainsPage />} />
          <Route path="domain-health" element={<DomainHealthPage />} />
          <Route path="support" element={<SupportPage />} />
          <Route path="sponsors" element={<SponsorsPage />} />
          <Route path="operators" element={<OperatorsPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="status" element={<StatusPage />} />
          <Route path="cleanup" element={<CleanupPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="search" element={<SearchPage />} />
          <Route path="top-consumers" element={<TopConsumersPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="feature-flags" element={<FeatureFlagsPage />} />
          <Route path="disposable-domains" element={<DisposableDomainsPage />} />
          <Route path="rate-limits" element={<RateLimitsPage />} />
          <Route path="user-webhooks" element={<UserWebhooksPage />} />
          <Route path="migrations" element={<MigrationsPage />} />
          <Route path="maintenance" element={<MaintenancePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </>
  );
}
